import React from "react";
import { Box } from "@mui/material";
import default_theme from "assets/themes/themes";

const PhaseArrow = ({ sx = {} }) => {
  return (
    <Box
      component="span"
      sx={{
        color: default_theme.palette.other.figmaBlue,
        mr: 1,
        position: "relative",
        top: "-2px",
        fontWeight: 700,
        ...sx // allows overrides
      }}
    >
      &gt;
    </Box>
  );
};

export default PhaseArrow;